import React from 'react';
import useDelayedFlag from 'react/hooks/useDelayedFlag';
import { CHAT_LOADING_DELAY } from 'react/chat/inner/display_pieces/loading/chatLoadingTimes';
import { __ } from 'i18n/index';

// A thin bar along the top of the message list for any message load, first or older.
export default function ChatLoadingBar({ isLoading }) {
	const visible = useDelayedFlag(isLoading, CHAT_LOADING_DELAY);
	if(!visible) {
		return null;
	}
	return <div className='chat-loading-bar' role='progressbar' aria-label={__('Loading messages')} />;
}
